import React, { useState, useEffect, useContext } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

// i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "../../Common/withRouter";

// users
import user4 from "../../../assets/images/logo-sm.png";
import axios from "axios";
import { apiUrl } from "../../../common/config/apiUrl";
import { useNavigate } from 'react-router-dom';
import toast from "react-hot-toast";
import { DataContext } from "../../../context/dataContext";

const ProfileMenu = (props) => {
  const [menu, setMenu] = useState(false);
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const { setToken } = useContext(DataContext);
  const [loading, setLoading] = useState(false); // Loading state



  useEffect(() => {
    if (localStorage.getItem("authUser ")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(localStorage.getItem("authUser "));
        setUsername(obj.displayName);
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        const obj = JSON.parse(localStorage.getItem("authUser "));
        if (obj.username) {
          setUsername(obj.username);
        } else {
          setUsername(obj.name);
        }
      }
    }
  }, [props.success]);

  const handleLogout = async () => {
    setLoading(true); // Set loading to true
    try {
      const headers = {
        "x-access-token": localStorage.getItem("token"),
      };

      const logoutResponse = await axios.post(`${apiUrl}/backend/logout`, {}, { headers });

      if (logoutResponse?.data?.code === 200) {
        setToken('');
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        navigate("/authentication/sign-in");
        toast.success(logoutResponse?.data?.message);
      } else {
        toast.error(logoutResponse?.data?.message);
      }
    } catch (error) {
      toast.error("An error occurred during logout.");
      navigate('/login');
    } finally {
      setLoading(false); // Set loading to false after logout process
    }
  };

  useEffect(()=> {

    const user = JSON.parse(localStorage.getItem("user"));

    if(user){
      setUsername(user?.name)
    }

  },[])


  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user bg-white"
            src={user4}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-1 fw-medium font-size-15 " style={{
            textTransform:"capitalize"
          }}>{username}</span>{" "}
          <i className="uil-angle-down d-none d-xl-inline-block font-size-15"></i>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
  <div className="dropdown-divider" />
  <Link 
    className={`dropdown-item ${loading ? 'disabled' : ''}`} 
    onClick={loading ? (e) => e.preventDefault() : handleLogout}
  >
    {loading ? ( 
      <span className="text-danger">
        <i className="uil uil-sign-out-alt font-size-18 align-middle me-1 text-muted"></i>
        Logging out...
      </span>
    ) : (
      <span>
        <i className="uil uil-sign-out-alt font-size-18 align-middle me-1 text-muted"></i>
        <span>{props.t("Logout")}</span>
      </span>
    )}
  </Link>
</DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);